import {Response} from "../../model";
import {ApiBuilder} from "..";

const downloadFile = (builder: ApiBuilder) =>
  builder.query<string, string>({
    query: id => ({
      url: `/api/public/file/download/${id}`,
      method: "GET",
    }),
  });

const previewFile = (builder: ApiBuilder) =>
  builder.query<string, string>({
    query: id => ({
      url: `/api/public/file/${id}`,
      method: "GET",
      responseHandler: async response => {
        if (!response.ok) {
          throw new Error("Failed to preview file");
        }
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      },
    }),
  });

const uploadFile = (builder: ApiBuilder) =>
  builder.mutation<Response<string>, File>({
    query: payload => {
      const formData = new FormData();
      formData.append(`file`, payload);

      return {
        url: "/api/file/upload",
        method: "POST",
        body: formData,
      };
    },
  });

const deleteFiles = (builder: ApiBuilder) =>
  builder.mutation<void, string[]>({
    query: body => ({
      url: "/api/file",
      method: "DELETE",
      body,
    }),
  });

export {previewFile, uploadFile, downloadFile, deleteFiles};
